<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="component"></column-header>
    <div class="tabulator-parent">
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="billingCustomer.company || billingCustomer.name">{{ billingCustomer.company }}<span v-if="billingCustomer.company && billingCustomer.name"> - </span>{{ billingCustomer.name }}</h3>
          <h3 v-else>{{ _('New Billing Customer') }}</h3>
        </div>
      </div>
      <editor-tabs :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('General customer information') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="company">{{ _('Company') }}</label>
                  <input type="text" class="form-control" id="customerCompany" :placeholder="_('Enter company')" name="company" v-model="billingCustomer.company" />
                </div>
                <div class="form-group">
                  <label for="company">{{ _('Department') }}</label>
                  <input type="text" class="form-control" id="customerDepartment" :placeholder="_('Enter department')" name="department" v-model="billingCustomer.department" />
                </div>
                <div class="form-group" v-if="isNetvisorEnabled">
                  <label for="netvisor">{{ _('Netvisor customer') }}</label>
                  <div class="input-group">
                    <model-list-select :list="netvisorCustomers" option-value="id" option-text="name" v-model="netvisorCustomer" @searchchange="searchNetvisorCustomers" :custom-text="formatNetvisorCustomer" :placeholder="_('Type to search customers')">
                    </model-list-select>
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button" v-on:click="updateNetvisorCustomers"><i class="fa fa-fw fa-refresh"></i></button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="address">{{ _('Address') }}</label>
                  <input type="text" class="form-control" id="customerAddress" :placeholder="_('Enter street address')" name="address" v-model="billingCustomer.address" />
                </div>
                <div class="form-group">
                  <label for="zip">{{ _('Postal code') }}</label>
                  <input type="text" class="form-control" id="customerZip" :placeholder="_('Enter postal code')" name="zip" v-model="billingCustomer.zip" />
                </div>
                <div class="form-group">
                  <label for="city">{{ _('City') }}</label>
                  <input type="text" class="form-control" id="customerCity" :placeholder="_('Enter city')" name="city" v-model="billingCustomer.city" />
                </div>
                <div class="form-group">
                  <label for="country">{{ _('Country') }}</label>
                  <select class="form-control" name="country" id="customerCountry" v-model="billingCustomer.country">
                    <option value="FI">{{ countries['FI'] }}</option>
                    <template v-for="(country, id) in countries" :key="id">
                      <option v-if="isPriorityCountry(id) && id !== 'FI'" :value="id">{{ country }}</option>
                    </template>
                    <option class="select-separator" disabled="disabled">────────────</option>
                    <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="paymentterm">{{ _('Payment term') }}</label>
                  <div class="input-group">
                    <input type="number" data-android-inputmode="decimal" class="form-control" id="customerPaymentterm" :placeholder="_('Enter payment term')" name="paymentterm" v-model="billingCustomer.paymentterm" />
                    <div class="input-group-addon">{{ _('d') }}</div>
                  </div>
                </div>
                <div class="form-group">
                  <label v-if="billingCustomer.allowmarketing">{{ _('Marketing allowed') }}</label>
                  <label v-else>{{ _('Marketing NOT allowed') }}</label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="phone">{{ _('Phone') }}</label>
                  <phone-number-input v-model="billingCustomerPhone" :placeholder="_('Enter customer phone')" />
                </div>
                <div class="form-group">
                  <label for="email">{{ _('Marketing Email') }}</label>
                  <input type="email" class="form-control" id="customerMarketingEmail" :placeholder="_('Enter marketing email address')" name="email" v-model="billingCustomer.email" />
                </div>
                <div class="form-group">
                  <label for="email">{{ _('Billing Email') }}</label>
                  <input type="email" class="form-control" id="customerBillingEmail" :placeholder="_('Enter billing email address')" name="billingemail" v-model="billingCustomer.billingemail" />
                </div>
                <div class="form-group">
                  <label for="ident" v-if="billingCustomer.company">{{ _('Business ID') }}</label>
                  <label for="ident" v-else>{{ _('Personal ID Number') }}</label>
                  <input type="text" class="form-control" id="customerIdent" :placeholder="billingCustomer.company ? _('Enter business ID') : _('Enter personal ID number')" name="ident" v-model="billingCustomer.ident" />
                </div>
                <div class="form-group">
                  <label for="evoice">{{ _('E-Invoice Address') }}</label>
                  <input type="text" class="form-control" id="customerEvoice" :placeholder="_('Enter e-invoice address')" name="evoice" v-model="billingCustomer.evoice" />
                </div>
                <div class="form-group">
                  <label for="evoiceint">{{ _('E-Invoice Intermediary') }}</label>
                  <select class="form-control" name="evoiceint" id="customerEvoiceInt" v-model="billingCustomer.evoiceint">
                    <option value="">{{ _('Select') }}</option>
                    <option v-for="int in evoiceInt" :value="int.id">{{ int.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="name">{{ _('Contact person') }}</label>
                  <input type="name" class="form-control" id="customerName" :placeholder="_('Enter contact person')" name="name" v-model="billingCustomer.name" />
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('links')" class="tab-pane active" id="links" v-if="isTabActive('links')" key="links">
            <div class="row">
              <div class="col-md-6" v-if="billingCustomer.id">
                <h3>{{ _('Clients') }}</h3>
                <draggable-multi-selector v-model="billingCustomer.sharedCustomer" :items="allCustomers" itemProperty="name" :selectorTitle="_('Link a Client')" />
              </div>
              <div class="col-md-6" v-if="billingCustomer.id">
                <h3>{{ _('Cost objects') }}</h3>
                <draggable-multi-selector v-model="billingCustomer.sharedDimension" :items="allDimensions" :groups="true" :single-select="isBrioxAccountingMode" itemProperty="name" :selectorTitle="_('Link a Cost object')" />
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('orders')" class="tab-pane active" id="orders" v-if="isTabActive('orders')" key="orders">
            <datatable :url="ordersUrl" :options="tableOptions" ref="datatable" v-if="billingCustomer.id" />
          </div>
          <div v-bind="tabPanel('subscriptions')" class="tab-pane active" id="subscriptions" v-if="isTabActive('subscriptions')" key="subscriptions">
            <subscriptions-panel v-if="billingCustomer.id" :billing-customer-id="billingCustomer.id" :show-charges="true" :details-trail="componentTrail" />
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <div class="flex-row">
          <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the customer? Deletion can\'t be undone.'))" type="button"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete billing customer') }}</span></button>
        </div>
        <div class="button-col flex-row">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'
import evoice from '~/lib/evoice'
import formatters from '~/lib/formatters'
import modals from '~/lib/modals'
import settingshelpers from '~/lib/settingshelpers'
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import { Datatable, DraggableMultiSelector, SubscriptionsPanel } from '#components'
import { ModelListSelect } from 'vue-search-select'
import PhoneNumberInput from '~/components/PhoneNumberInput'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      billingCustomer: {},
      saving: false,
      netvisorCustomer: {},
      netvisorCustomers: [],
      allCustomers: [],
      allDimensions: [],
      tableOptions: {
        rowFormatter: $this.orderRowFormatter(),
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [{
          title: _('Order no.'),
          field: 'id',
          width: 80,
          responsive: 0
        },
        {
          title: _('Customer name'),
          field: 'name',
          widthGrow: 4,
          formatter: $this.orderCustomerFormatter(),
          responsive: 0
        },
        {
          title: _('Total'),
          field: 'totalWithDelivery',
          widthGrow: 2,
          formatter: $this.numberFormatter(),
          hozAlign: 'right'
        },
        {
          title: _('Status'),
          field: 'paid',
          widthGrow: 2,
          formatter: $this.paidFormatter()
        },
        {
          title: _('Order date'),
          field: 'orderdate',
          widthGrow: 3,
          formatter: $this.dateAndTimeFormatter()
        },
        {
          title: _('Processed'),
          field: 'processed',
          widthGrow: 2,
          formatter: $this.processedFormatter()
        },
        {
          title: _('Delivery method'),
          field: 'delivery',
          widthGrow: 2,
          formatter: $this.deliveryMethodFormatter()
        }
        ],
        initialSort: [{
          column: 'id',
          dir: 'desc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.displayOrder(id, name)
        }
      }
    }
  },
  props: ['selectedBillingCustomer'],
  mixins: [changewatcher, components, evoice, formatters, modals, settingshelpers],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'links', label: this._('Links') },
        { id: 'orders', label: this._('Orders') },
        { id: 'subscriptions', label: this._('Subscriptions'), hidden: !this.isFeatureEnabled('paymentplans') }
      ])
    },
    ...mapGetters(['countries']),
    isNewBillingCustomer () {
      return !this.billingCustomer || !this.billingCustomer.id
    },
    billingCustomerPhone: {
      get () {
        if (!this.billingCustomer || !this.billingCustomer.phone) {
          return ''
        }
        return this.billingCustomer.phone
      },
      set (newValue) {
        if (newValue) {
          newValue = newValue.replace(/\s/g, '')
        }
        this.billingCustomer.phone = newValue
      }
    },
    billingCustomerTitle () {
      if (this.isNewBillingCustomer || !this.billingCustomer) {
        return this._('Create a new billing customer')
      }
      return this.billingCustomer.company
    },
    settings () {
      return this.shopSettings(this.shopId)
    },
    isNetvisorEnabled () {
      return parseInt(this.settings.pay_option13)
    },
    ordersUrl () {
      if (!this.billingCustomer) {
        return ''
      }
      return this.baseDomain + this.shopId + '/billingcustomers/' + this.billingCustomer.id + '/orders.json?apikey=' + this.apiKey + '&rawformat=true'
    }
  },
  methods: {
    isPriorityCountry (id) {
      return ['SE', 'NO', 'DK', 'EE', 'RU'].indexOf(id) !== -1
    },
    isConditionalTab(tab) {
      if (tab === 'links' || tab === 'orders' || tab === 'subscriptions') {
        return this.isNewBillingCustomer
      }
      return false
    },
    loadBillingCustomer (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        if (response.data.netvisorid) {
          try {
            this.netvisorCustomer = await this.loadNetvisorCustomer(response.data.netvisorid)
            this.netvisorCustomers = [this.netvisorCustomer]
          } catch(e) {}
        }
        this.billingCustomer = response.data
        this.storeState()
        this.loading = false
        resolve(this.billingCustomer)
      })
    },
    loadNetvisorCustomer (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/netvisorcustomers/' + id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          reject()
          return
        }
        resolve(response.data)
      })
    },
    getSaveData () {
      return { ...this.billingCustomer }
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/billingcustomers/' + this.billingCustomer.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the customer failed!'))
      }
      this.storeState()
      this.showNotification(this._('Customer deleted!'))
      this.close()
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let billingcustomerId
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/billingcustomers/' + data.id + '.json?apikey=' + this.apiKey, data)
          billingcustomerId = data.id
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/billingcustomers.json?apikey=' + this.apiKey, data)
          billingcustomerId = response.data
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (billingcustomerId) {
        await this.loadBillingCustomer(billingcustomerId)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.billingCustomer)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    setParams (params) {
      this.billingCustomer = params
    },
    async updateNetvisorCustomers () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/netvisorcustomers.json?apikey=' + this.apiKey, { import: true })
      } catch(e) {
        return false
      }
    },
    searchNetvisorCustomers: debounce(async function (text, done) {
      if (text.length < 2) {
        return
      }
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/netvisorcustomers.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&sSearch=' + escape(text) + '&iDisplayStart=0&iDisplayLength=100&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.netvisorCustomers = response.data
    }),
    formatNetvisorCustomer(nc) {
      if (!nc) {
        return '-'
      }
      return nc.name + ' (' + this._('Netvisor key') + ': ' + nc.netvisorkey + ')'
    },
    async loadCustomers () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/customers.json?apikey=' + this.apiKey)
      } catch(e) {
        return false
      }
      this.allCustomers = response.data
    },
    async loadDimensions () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/dimensions.json?apikey=' + this.apiKey)
      } catch(e) {
        return false
      }
      let dim = response.data
      let dimensions = []
      for (let i = 0; i < dim.length; i++) {
        if (parseInt(dim[i].level) === 0) {
          let currParent = dim[i]
          let currChildren = []
          for (let j = 0; j < dim.length; j++) {
            if (dim[j].parentid === currParent.id) {
              currChildren.push(dim[j])
            }
          }
          currParent.children = currChildren
          dimensions.push(currParent)
        }
      }
      this.allDimensions = dimensions
    },
    displayOrder (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          orderId: id,
          trail: this.componentTrail
        },
        skipState
      })
    }
  },
  watch: {
    netvisorCustomer (newValue) {
      if (newValue && newValue.netvisorkey) {
        this.billingCustomer.netvisorid = newValue.netvisorkey
      } else {
        this.billingCustomer.netvisorid = null
      }
    }
  },
  components: {
    Datatable,
    DraggableMultiSelector,
    ModelListSelect,
    PhoneNumberInput,
    SubscriptionsPanel
  },
  created () {
    if (this.component && this.component.initData) {
      if (parseInt(this.component.initData.billingCustomerId)) {
        this.loadBillingCustomer(this.component.initData.billingCustomerId)
      } else if (this.component.initData.billingCustomer) {
        this.billingCustomer = Object.assign({}, this.component.initData.billingCustomer)
      }
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.billingCustomer && parseInt(this.billingCustomer.id, 10) !== parseInt(this.component.initData.billingCustomerId, 10) && !this.deleted) {
        if (parseInt(this.component.initData.billingCustomerId)) {
          try {
            await this.loadBillingCustomer(this.component.initData.billingCustomerId)
          } catch(e) {}
        }
      }
    }
  },
  async mounted () {
    if (this.selectedBillingCustomer) {
      this.loadBillingCustomer(this.selectedBillingCustomer.id)
    }
    this.loadCustomers()
    this.loadDimensions()
    if(!this.events) {
      let events = {}
      events['showBillingCustomerDetailsParams'] = (message) => {
        this.setParams(message)
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
